import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getUserAdminStatus } from '../utils/superAdminUtils';
import LoaderScreen from './LoaderScreen';

const SuperAdminRoute = ({ children }) => {
  const [adminStatus, setAdminStatus] = useState(null);

  useEffect(() => {
    const checkAdminStatus = async () => {
      const status = await getUserAdminStatus();
      setAdminStatus(status);
    };

    checkAdminStatus();
  }, []);

  if (adminStatus === null) {
    return <LoaderScreen subtitle="Checking admin access" />;
  }

  // If user is not an admin at all, redirect to home
  if (!adminStatus.isAdmin) {
    return <Navigate to="/login" />;
  }

  // If user is admin but not super admin, redirect to video analysis
  if (!adminStatus.isSuperAdmin) {
    return <Navigate to="/admin/video-analysis" />;
  }

  // User is super admin, allow access
  return children;
};

export default SuperAdminRoute;
